import './App.css';
import BuyFromMarketplace from './components/BuyFromMarketplace';
import ConnectWallet from './components/ConnectWallet';
import ListToMarketplace from './components/ListToMarketplace';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="logo512.png" height="100" alt="No logo" />
        <h1>BNS Marketplace</h1>
        <h2>List - Buy</h2>
        <h2>Demo version, not yet ready for primetime.</h2>
        <ConnectWallet />
        <ListToMarketplace />
        <BuyFromMarketplace />
        <p>
          <i>dartman#1304</i>
        </p>
      </header>
    </div>
  );
}

export default App;
